import React from "react";
import { connect } from "react-redux";
import { fetchRentableCircles } from "../../store/rentable_circles/operations";
import { navigate } from "../../store/navigation/operations";
import LoadingIndicator from "../../components/LoadingIndicator";
import { Translate } from "react-redux-i18n";
import MyCircleCard from "../../components/MyCircleCard";
import { getRentableCircles, isFetchingRentableCircles } from "../../store/rentable_circles/selectors";
import { isLoggedIn } from "../../store/iam/selectors";

const NonIdealState = () => {
    return <>No rental products available</>
}

class RentableCirclesSection extends React.Component {
    constructor(props) {
        super(props);
        this.circleCardClicked = this.circleCardClicked.bind(this);
    }

    componentDidMount() {
        this.props.fetchRentableCircles();
    }

    circleCardClicked(circle) {
        this.props.navigate(`/rent-circle/${circle}`);
    }

    render() {
        return (
            <div className={`content-wrapper ${this.props.circles ? "has-sidebar" : null}`}>
                <div className="wide-content">
                    <h1 className="bp3-heading">
                        <Translate value="my_circles.heading" />
                    </h1>
                    <div className="blocked-card-list my-circles">
                        {this.props.loading && <LoadingIndicator />}
                        {!this.props.loading &&
                            this.props.circles_at_address && <>
                                {Object.keys(this.props.circles_at_address).length === 0 && <NonIdealState />}
                                {Object.keys(this.props.circles_at_address) && Object.values(this.props.circles_at_address).map((circles_at_address, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            Address: {circles_at_address[0].address}
                                            {circles_at_address.map((circle) => {
                                                return (<MyCircleCard
                                                    key={circle.guid}
                                                    circle={circle}
                                                    onClick={this.circleCardClicked}
                                                />)
                                            })}
                                        </React.Fragment>)
                                })
                                }
                            </>}

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: isLoggedIn(state),
        loading: isFetchingRentableCircles(state),
        circles_at_address: getRentableCircles(state),
        locale: state.i18n.locale,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchRentableCircles: () => dispatch(fetchRentableCircles()),
    navigate: (to) => dispatch(navigate(to)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RentableCirclesSection);
